import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import themeReducer from './slices/theme';
import openAIReducer from './slices/open_ai';
import socketReducer from './slices/socket';
import timerReducer from './slices/timer';
import audioReducer from './slices/audio';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        open_ai: openAIReducer,
        socket: socketReducer,
        timer: timerReducer,
        audio: audioReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;